/*
 * Data List Module
 * Description:
 * Module to display list from data and perform actions as needed
 *
 * Purpose: It is a multi-purpose module that fetches/displays data from client or server (live search or 
 * otherwise) and depending on user's requirement can search, fetch more data or both. 
 * User can select items (multi or single), perform actions whenever required
 * 
 * Inputs
 * - containerId: Id of the container containing the data list
 * - useApi: Fetch data from the server. true (default) if data is to fetched from the server
 * - useApiAsData: Should live data be used. true (default) if live data needs to be fetched everytime
 * - selectable: Are the li's selectable. false (default) if Li's 
 * - multiSelect: If mulitple li's can be selected. false (default) if only one item in the list can be selected
 * - searchable: If li's need to be searchable. false (default) if list does not need to be searched
 * - lazyload: If data can be lazy loaded. false (default) if lazy loaded is not needed
 * - apiData: If data needs to be sent to server
 * - searchOptions: If data is to be searched, which keys need to be used for searching
 * - searchId: If data list is searchable, provide ID of the search input box
 * - elLazyButtonId: If data is to be lazy loaded, provide id of that button
 * - keys: If data list is searchable, provide keys to be used for searching
 * - template accepts two parameters: data and props
 * 
 * Output
 * - function that has one accessible method init 
 * - template returns HTML string to be rendered
 *
 * @functions
 * precessRenderResponse - pre process api response before using it
 *
 * @authors: Chiran Doshi and Elton Jain
 */

define('DataList',['jquery', 'UI', 'JSTemplate', 'Helper', 'modules/common/Constants', 'Auth'], function($, UI, template, Helper, Constants, Auth) {

    'use strict';

    return function() {

        var defaults = {
                useApi: true,
                useApiAsData: false,
                selectable: false,
                multiSelect: false,
                searchable: false,
                lazyLoad: false,
                startPage: 1,
                apiData: {
                    page: 1
                },
                searchOptions: {
                    id: 'id'
                },
                elNoResultsId: null,
                onfetchCallback: null,
                customFuseField: null,
                bindSelectable: true,
                autoload: true,
                isBind: true,
                limitKey: 'activity_limit',
                showNoMore: false,
                authCheck: false,
                rpp: null,               // Records per page | optional
                append: true,
                autoscroll: false,
                precessResponse: null
            },
            o,
            allItems = [],
            $searchEl,
            $elContainer,
            $elLazyButton,
            searchData = [],
            searchOptions,
            apiDataLoaded,
            $elNoResults,
            initialFetch = false,

            /**
             * [update updates the options for the Data List instance and refreshes the data]
             *
             * @param Integer page [page number to be sent to the server]
             */
            update = function(options) {
                o = $.extend(o, options);
                o.apiData.page = 1;
                init(options);
            },

            /**
             * [_setFuseData sets data that needs to be fuse searched]
             *
             * @param Array data [array containing the data]
             */
            _setFuseData = function(data) {
                if (o.searchable) {
                    require(['fuse'], function(Fuse) {
                        searchData = new Fuse(data, o.searchOptions);    
                    });
                }
            },

            /**
             * [_showNoResults handles what to do in case search produces no results]
             * 
             * @param  Array results [content returned after search]
             *
             */
            _showNoResults = function(data) {
                if(o.elNoResultsId) {
                    if (o.lazyLoad) {
                        if (allItems.length > 0) {
                            $('#' + o.elNoResultsId).addClass('hidden');
                        } else {
                            $('#' + o.elNoResultsId).removeClass('hidden');
                        }
                    } else {

                        if (data.length > 0) {
                            $('#' + o.elNoResultsId).addClass('hidden');
                        } else {
                            $('#' + o.elNoResultsId).removeClass('hidden');
                        }
                    }
                }
            },

            /**
             * [_updateDisplay renders the content to the container]
             *
             * @param  Array results [content to be rendered]
             *
             */
            _updateDisplay = function(results) {

                var html = template(o.template, {
                    data: results,
                    options: o,
                    props: o,
                    initialFetch: initialFetch
                });

                if (o.lazyLoad) {
                    if(o.append) {
                        $elContainer.append(html);    
                    } else {
                        $elContainer.prepend(html);
                    }
                    
                    $elLazyButton.find('a').removeClass('loading');
                    if(!results.length && o.showNoMore) {
                        $elContainer.addClass('nomore');
                    }
                } else {
                    $elContainer.html(html);
                }
                // $elNoResults = $(o.elNoResultsClass);

                _showNoResults(results);

                $elContainer.removeClass('loading');
                // var data = o.keys ? results[o.keys[0]] : results;
                if(o.rpp && results) {
                    if(results.length < o.rpp) {
                        _hideLazyButton(results, true);
                    } else {
                        _hideLazyButton(results);
                    }
                }

                if(!initialFetch) {
                    initialFetch = true;
                }

            },

            /**
             * [_showResults only shows results relevant to search field]
             *
             * @param  Array results [content to be rendered]
             *
             */
            _showResults = function(results) {
                var allLi = $('#' + o.containerId + ' li').not('#'+o.elNoResultsId),
                    visibleLi,
                    id;

                for (var i = 0; i < allLi.length; i++) {
                    id = $(allLi[i]).data('id');
                    if (results.indexOf(id) >= 0) {
                        $(allLi[i]).show();
                    } else {
                        $(allLi[i]).hide();
                    }
                }

                // Sort visible li's based on fuse score
                visibleLi = $('#' + o.containerId + ' li:visible');

                visibleLi.sort(function(a, b) {
                    var a_id = $(a).data('id'),
                        b_id = $(b).data('id');

                    if (results.indexOf(a_id) < results.indexOf(b_id)) {
                        return -1;
                    } else {
                        return 1;
                    }

                }).appendTo('#' + o.containerId);

                _showNoResults(results);
            },

            /**
             * [_quickSearch performs search on the array of objects using the searchKey]
             *
             * @param  String  searchKey  [string that needs to be searched]
             * @param  Literal 100        [Time in milliseconds to debounce]
             *
             */
            _quickSearch = function(searchKey) {
                var results = [];
                if (searchKey === '') {
                    for (var i = 0; i < searchData.list.length; i++) {
                        results[i] = searchData.list[i].id;
                    }
                } else {
                    results = searchData.search(searchKey);
                }

                if ((o.useApi === true && o.useApiAsData === true) || (o.useApi === false)) {
                    _showResults(results);
                }


            },


            getList = function(searchKey) {
                if (o.useApi === true && (o.useApiAsData === false || apiDataLoaded === false)) {

                    _fetchData().done(_postFetch);

                } else {
                    _quickSearch(searchKey);
                }
            },


            /**
             * [_bindEvents binds the events to the view]
             */
            _bindEvents = function() {

                // Bind event if search is enabled
                if (o.searchable) {
                    $searchEl.on('keyup', Helper.debounce(function() {

                        getList($searchEl.val());

                    }, 100));
                }

                // Bind event if selectable is enabled
                if (o.selectable && o.bindSelectable) {
                    $elContainer.on('click', 'label', function(ev) {

                        if($(ev.target).is('input')) {
                            if (o.multiSelect) {
                                $(this).closest('li').toggleClass('selected');
                            } else {
                                $elContainer.children().removeClass('selected');
                
                                $(this).closest('li').addClass('selected');
                            }    
                        }
                        
                    });

                    // Prevent click of anchor tag in selectable list
                    $elContainer.on('click', 'a', function(ev) {
                        var input = $(this).closest('li').find('input'),
                            state = input.prop('checked');
                        ev.preventDefault();
                        if (o.multiSelect) {
                                $(this).closest('li').toggleClass('selected');
                                input.prop('checked',!state);
                            } else {
                                $elContainer.children().removeClass('selected');
                                $(this).closest('li').addClass('selected');
                                input.prop('checked',true);
                            }    
                        return false;
                    });
                }

                // Bind event if lazy loading is enabled
                if (o.lazyLoad) {
                    UI.$b.on('click', '#' + o.elLazyButtonId, function(e) {
                        e.preventDefault();
                        o.apiData.page++;
                        if(o.authCheck && o.apiData.page > 1) {
                            if (!Auth.checkLoginRequired({source: 'datalist lazyload '+o.elLazyButtonId})) {
                                return false;
                            }
                        }
                        $(this).find('a').addClass('loading');
                        _fetchData().done(_postFetch);
                        return false;
                    });
                }

                if(o.autoscroll) {

                    UI.$w.on('scroll', Helper.debounce(function() {

                        // Doc height - 200 && 
                        var pageScrollHeight = UI.$d.outerHeight() - UI.$w.height();
                        if(window.scrollY >= pageScrollHeight-400 && window.scrollY > 100) {
                            if($('#' + o.elLazyButtonId).length > 0) {
                                $('#' + o.elLazyButtonId).trigger('click');
                            }
                            
                        }
                    
                    }, 100));
                }

            },

            /**
             * [_fetchData gets the data from the server]
             *
             * @param  {[type]} o [description]
             *
             * @return promise   [returns a promise that can be resolved]
             */
            _fetchData = function() {

                return $.ajax({
                    url: o.api,
                    type: 'POST',
                    data: o.apiData
                });

            },

            /**
             * [_postFetch function describes what needs to be done after post successfully returns]
             *
             * @param  Object results [response from the server]
             *
             */
            _postFetch = function(results) {

                $elContainer.removeClass('loading');
                if (results.status) {
                    var data;

                    if(o.customFuseField) {
                        data = results.response[o.customFuseField];
                    } else {
                        data = results.response;
                    }

                    allItems = allItems.concat(data);

                    apiDataLoaded = true;

                    _hideLazyButton(data);
                    _setFuseData(data);
                    
                    if(o.precessRenderResponse) {
                        // Use pre-processed data, specific key, or updated
                        _updateDisplay(o.precessRenderResponse(data));
                    } else {
                        _updateDisplay(data);
                    }
                    

                    if(o.onfetchCallback) {
                        o.onfetchCallback(results, o);
                    }

                    if(o.showNoMore) {
                        if(data.length < Constants.limits[o.limitKey]) {
                            $elContainer.addClass('nomore');
                            _hideLazyButton(results, true);
                        } else {
                            _hideLazyButton(data, false);
                        }
                    }
                } else {
                    _showNoResults(allItems);
                    _hideLazyButton([]);
                }
            },

            /**
             * [_hideLazyButton function styles lazy load button as necessary]
             *
             * @param  Array items [content of interest]
             *
             */
            _hideLazyButton = function(items, forceHide) {
                
                if (o.lazyLoad) {
                    
                    if($elLazyButton.length === 0) {
                        $elLazyButton = $('#' + o.elLazyButtonId);
                    }

                    if(forceHide === true) {
                        $elLazyButton.addClass('hidden');
                    } else {
                        if (items.length === 0) {
                            $elLazyButton.addClass('hidden');
                        } else {
                            $elLazyButton.removeClass('hidden');
                        }    
                    }
                    
                } else {
                    return;
                }
            },

            getData = function() {
                return allItems;
            },

            reset = function() {
                if($elContainer) {
                    $elContainer.html('');
                    init(o);
                }
            },

            empty = function() {
                if($elContainer) {
                    $elContainer.html('');
                }
            },


            /**
             * [init function is to set the parameters]
             *
             * @param  Object options [parameters that defines how the instance needs to be setup]
             *
             */
            init = function(options) {
                o = $.extend(defaults, options);

                // Check if required parameters are set. If not throw error
                if ((o.searchable && !o.searchId && !options.keys) ||
                    (!o.containerId) ||
                    (!o.template) ||
                    (o.lazyLoad && !o.elLazyButtonId) ||
                    (o.useApi && !o.api) || 
                    (!o.useApi && !o.data)) {
                    throw ('Data List : Pass arguments correctly');
                }

                // ID of the container for data to be displayed
                $elContainer = $('#' + o.containerId);

                if(o.autoload) {
                    $elContainer.addClass('loading');    
                }
                

                if(!o.useApi) {
                    _updateDisplay(o.data);
                }

                // If data is searchable then require fuse and set the search options
                if (o.searchable) {

                    if (!o.useApi) {
                        _setFuseData(o.data);
                    }

                    o.searchOptions.keys = options.keys;
                    $searchEl = $('#' + o.searchId); // ID of the search container
                }

                // If data is to be fetched using API
                if (o.useApi) {
                    if(o.autoload) {
                        _fetchData().done(_postFetch);    
                    } else {
                        initialFetch = true;
                    }
                }

                // If lazy load is enabled
                if (o.lazyLoad) {
                    $elLazyButton = $('#' + o.elLazyButtonId);
                }

                if(o.isBind) {
                    _bindEvents();    
                }
                
            };

        return {
            init: init,
            update: update,
            reset: reset,
            getList: getList,
            empty: empty,
            getData: getData
        };
    };
});
